import React from 'react';

function RadioButton({ name, checked, onClick }: any) {
  return <input onClick={onClick} className='custonRadioButton' type='radio' name={name} checked={checked} />;
}

export default RadioButton;
